// Note:
// gtag.js is supported in web apps but restricted in Chrome Extensions
// due to Content Security Policy (CSP) — extensions cannot load external scripts like gtag.js.
// In Chrome Extensions, use Google Analytics Measurement Protocol via fetch() instead.

// Conversely, web apps cannot securely use Measurement Protocol client-side
// (due to API secret exposure), so gtag.js should be used in that case.

import getDeviceData, { isProduction, isCX } from '../api/DeviceInfo';
// Google Analytics Event Logging Utility
export async function logGAEvent(eventType, apiClient, eventData = {}) {
  let deviceData = sessionStorage.getItem('deviceData');
  deviceData = deviceData ? JSON.parse(deviceData) : null;
  if (!deviceData) {
    deviceData = await getDeviceData();
    sessionStorage.setItem('deviceData', JSON.stringify(deviceData));
  }

  if (isCX()) {
    sendGAEvent(eventType, deviceData, eventData, apiClient);
  } else if (isProduction) {
    setupAnalytics(deviceData, eventData, apiClient);
    window.gtag('event', eventType, {
      debug_mode: true,
      timestamp: new Date().toISOString(),
      conversation_id: eventData?.conversation_id || 'Unknown',
      config_id: eventData?.config_id || 'Unknown',
    });
  }

  // Helper function to extract user information from eventData and apiClient
  function extractUserInfo(eventData = {}, apiClient = {}) {
    const userId =
      eventData?.referralCode ||
      apiClient?.referralCode ||
      eventData?.email ||
      apiClient?.email ||
      'anonymous';
    const userName = eventData?.name || apiClient?.name || 'Unknown';
    const emr = eventData?.emr || apiClient?.EMR || apiClient?.emr || 'Unknown';
    const groupSubscriptionId = apiClient?.groupSubscriptionId || 'Unknown';
    return { userId, userName, emr, groupSubscriptionId };
  }

  function setupAnalytics(deviceData, eventData, apiClient) {
    const { userId, userName, emr, groupSubscriptionId } = extractUserInfo(
      eventData,
      apiClient,
    );
    const alreadySet = sessionStorage.getItem('gaUserInitialized');
    // if (alreadySet === 'true') return; // Skip if already initialized

    // Step 1: Configure global user_id
    window.gtag('config', 'G-HTP712JW8M', {
      user_id: userId,
    });

    // Step 2: Set user_properties
    window.gtag('set', 'user_properties', {
      user_name: userName,
      user_id: userId,
      platform: 'web',
      emr: emr,
      group_subscription_id: groupSubscriptionId,
      ...deviceData,
    });

    sessionStorage.setItem('gaUserInitialized', 'true');
  }

  function sendGAEvent(eventName, deviceData, eventData = {}, apiClient) {
    const GA_MEASUREMENT_ID = 'G-HTP712JW8M';
    const API_SECRET = '1KqEF492S'; // it's ok on client side for Google Analytics Measurement Protocol may be change this regularly to prevent abuse
    const CLIENT_ID = 'extension-' + crypto.randomUUID(); // Generate or store in localStorage

    const { userId, userName, emr, groupSubscriptionId } = extractUserInfo(
      eventData,
      apiClient,
    );

    // Convert deviceData into user_properties
    const user_properties = {
      user_name: userName,
      user_id: userId,
      emr: emr,
      group_subscription_id: groupSubscriptionId,
      platform: 'chrome_extension',
      ...Object.fromEntries(
        Object.entries(deviceData).map(([key, val]) => [key, val]),
      ),
    };
    const payload = {
      client_id: CLIENT_ID,
      user_id: userId,
      events: [
        {
          name: eventName,
          params: {
            timestamp: new Date().toISOString(),
            conversation_id: eventData?.conversation_id || 'Unknown',
            config_id: eventData?.config_id || 'Unknown',
          },
        },
      ],
      user_properties,
    };

    fetch(
      `https://www.google-analytics.com/mp/collect?measurement_id=${GA_MEASUREMENT_ID}&api_secret=${API_SECRET}`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`GA tracking failed with status: ${response.status}`);
        }
        console.log('GA Event sent successfully:', response);
        return true; // Optional: handle the response if needed
      })
      .catch((err) => {
        console.error('GA tracking failed:', err);
      });
  }
}
